import { chatFeatureKey } from '../key';

export const getChatroomStatsQueryKey = () => [...chatFeatureKey, 'stats'] as const;
